var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'AAutoCompleteOptGroup';
export default OptGroup;